module.exports = __webpack_public_path__ + "media/images/themes/pink_softness/main_bg3-0acd47e0ad13a774d997d30f8a402b1f.png";